import React from 'react';
import { Box, Typography } from '@mui/material';
const clamp = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  overflowWrap: 'anywhere',
};
// Build60 SponsoredInlineCard: title15/18, description12/16, two lines each.
export default function SponsoredInlinePreview({ headline, subheadline }) {
  return (
    <Box sx={{ minWidth: 0, flex: 1, py: 1.5, px: 1.5, pr: 4 }}>
      <Typography fontWeight={700} sx={{ fontSize: 15, lineHeight: '18px', ...clamp }}>
        {headline || '광고 제목'}
      </Typography>
      {subheadline ? (
        <Typography
          color="text.secondary"
          sx={{ mt: '2px', fontSize: 12, lineHeight: '16px', ...clamp }}
        >
          {subheadline}
        </Typography>
      ) : null}
    </Box>
  );
}
